var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenaaamHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 32,
    viewBox: "0 0 49 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Benaam - SVG Logo 1",
    clipPath: "url(#clip0_41_119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M48.9995 2.43478H45.5488V5.91304H48.9995V2.43478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M23.8101 10.0869H20.3594V13.5652H23.8101V10.0869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    d: "M0 8.34783V2.78261H38.6479V0H44.169V8.34783H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M38.6479 23.6522V26.4348H0V32H44.169V23.6522H38.6479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    d: "M38.6479 11.8261V14.6087H5.52113V11.8261H0V20.1739H44.169V11.8261H38.6479Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenaaamHeader);
export default __webpack_public_path__ + "static/media/benaaam-header.f28b2e972381fb459e0a5c0c86599f16.svg";
export { ForwardRef as ReactComponent };